<template>
    <b-form-group>
        <div class="element_holder">
            <div class="element_label">
                <label id="card_number">Card Number:</label>
                <label id="expiration">Expiration/CVC:</label>
                <label id="country">Country:</label>
            </div>
            <div id="payment-element"></div>
        </div>
        <b-form-group label="" label-cols="3">
            <div
                v-if="
                    !data.isPayNow &&
                    data.trans_type != 'payment_method' &&
                    data.save_card == 1
                "
                class="mt-2"
                style="font-size: 12px; color: #6d6e78;"
            >
                By providing your card information, you allow
                {{ clinicName }} to charge your card for future payments in
                accordance with their terms.
            </div>
            <b-form-checkbox
                v-if="!data.isPayNow && data.trans_type != 'payment_method'"
                id="save_card"
                v-model="data.save_card"
                class="mt-2"
                value="1"
                plain
                unchecked-value="0"
                >Save card as payment method</b-form-checkbox
            >
        </b-form-group>
    </b-form-group>
</template>
<style type="text/css" lang="scss">
.element_holder {
    display: flex;
    margin-top: -0.3rem;
}
.element_label {
    width: 26%;
    height: 120px;
    float: left;

    label {
        margin-top: 11px;
        margin-bottom: 10px;
    }
}

#payment-element {
    width: 70%;
}

label[for="save_card"] {
    margin-top: 1px;
}
</style>
<script>
import PaymentDialogHelper from "@/module/payment/helper.js";
import { debounce, get } from "lodash";

export default {
    name: "StripeElements",
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        metadata: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mixins: [PaymentDialogHelper],
    data() {
        return {
            stripe: null,
            elements: null,
            paymentIntentId: null,
            termTextShow: false,
            clinicName: ""
        };
    },
    mounted() {
        let self = this;
        self.clinicName = get(this, "$root.setting.business.name");
        if (!self.data.isPayNow) {
            // eslint-disable-next-line no-undef
            self.data.stripe = Stripe(
                _.get(self, "$root.cc_extension.STRIPE_PUBLIC_KEY", ""),
                {
                    stripeAccount: _.get(
                        self,
                        "$root.cc_extension.STRIPE_ACCOUNT_ID",
                        ""
                    )
                }
            );

            self.initializeStripe();
        } else {
            self.getStripeDetails();
        }
    },
    methods: {
        async getStripeDetails() {
            let self = this;
            await self
                ._getStripeDetails(self.data.business_id)
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    self.data.stripe = Stripe(response.public_key, {
                        stripeAccount: response.account_id
                    });
                    self.initializeStripe();
                });
        },
        async initializeStripe() {
            let self = this;
            if (self.data.trans_type != "payment_method") {
                self.data.save_card = 1;
            }
            let metadata = self._generateMetadata(
                {
                    ...self.metadata,
                    userId: self.$root.currentActor.id
                },
                self.metadata.is_census
            );
            let trans_type =
                _.get(self.data, "trans_type") == "payment_method"
                    ? "payment_method"
                    : "payment";
            self.$emit("isElementsLoaded", false);

            self.$http
                .post(process.env.BARRAMUNDI + "payment/stripe/secret", {
                    amount: self.data.payment_amount,
                    client_id: self.data.client
                        ? self.data.client.id
                        : self.data.client_id,
                    trans_type: trans_type,
                    business_id: self.data.business_id,
                    input_metadata: metadata
                })
                .then(function (response) {
                    if (response.data.response.client_secret) {
                        let clientSecret = response.data.response.client_secret;
                        self.paymentIntentId =
                            response.data.response.transaction_id;
                        self.data.elements = self.data.stripe.elements({
                            clientSecret
                        });
                        self.termTextShow =
                            !self.data.isPayNow &&
                            self.data.trans_type != "payment_method" &&
                            self.data.save_card;

                        const appearance = {
                            theme: "stripe",
                            variables: {
                                fontFamily:
                                    "Avenir, Verdana, Helvetica, Arial, sans-serif",
                                fontSizeBase: "14px"
                            },
                            rules: {
                                ".Label": {
                                    fontSize: "0px"
                                },
                                ".Input": {
                                    padding: "6px",
                                    paddingLeft: "0.55rem",
                                    boxShadow: "none",
                                    border: "1px solid #ced4da"
                                },
                                ".TermsText": {
                                    fontSize: "0px",
                                    marginTop: "0px"
                                },
                                ".Input--invalid": {
                                    border: "1px solid #b94a48",
                                    backgroundColor: "#FDD",
                                    color: "#212529"
                                }
                            }
                        };
                        self.data.elements = self.data.stripe.elements({
                            appearance,
                            clientSecret
                        });

                        const paymentElement = self.data.elements.create(
                            "payment",
                            {
                                wallets: {
                                    applePay: "never",
                                    googlePay: "never"
                                }
                            }
                        );
                        paymentElement.mount("#payment-element");

                        paymentElement.on("ready", function (event) {
                            self.$emit("isElementsLoaded", true);
                        });
                        paymentElement.on("change", function (event) {
                            if (event.complete) {
                                let stripe2 = self.data.stripe;
                                self.$emit("isDisableSave", false);

                                if (self.data.stripe?.stripe) {
                                    stripe2 = self.data.stripe.stripe;
                                }

                                self.data["stripe"] = {
                                    elements: self.data.elements,
                                    clientSecret: clientSecret,
                                    stripe: stripe2
                                };
                            } else {
                                self.$emit("isDisableSave", true);
                            }
                        });
                    } else {
                        self._message("Error initializing payment", "danger");
                    }
                });
        },
        /**
         *
         * confirm a PaymentIntent using data collected by the Payment Element.
         */
        async confirmPaymentStripe() {
            let paymentIntent = [];
            let self = this;
            await this._confirmPaymentStripe(
                this.data.stripe.elements,
                this.data.stripe.stripe
            ).then(function (response) {
                if (response.error) {
                    paymentIntent["error"] = response.error;
                    paymentIntent["code"] = 404;
                    self._message(response.error.message, "danger");
                    self.$emit("isElementsLoaded", true);
                } else if (
                    response.paymentIntent &&
                    response.paymentIntent.status === "succeeded"
                ) {
                    paymentIntent = response.paymentIntent;
                    paymentIntent["code"] = 200;
                }
            });
            return paymentIntent;
        },
        /**
         *
         * complete the setup using details collected by the Payment Element
         */
        async confirmSetupStripe() {
            let setupIntent = null;
            let self = this;
            await this._confirmSetupStripe(
                this.data.stripe.elements,
                this.data.stripe.stripe
            ).then(function (response) {
                if (response.error) {
                    self._message(response.error.message, "danger");
                    self.$emit("isElementsLoaded", true);
                    return null;
                } else if (
                    response.setupIntent &&
                    response.setupIntent.status === "succeeded"
                ) {
                    setupIntent = response.setupIntent;
                }
            });
            return setupIntent;
        },
        handlePaymentAmountChange(amount) {
            this.updatePaymentIntent(this.paymentIntentId, amount);
        },
        async updatePaymentIntent(paymentIntentId, amount) {
            let self = this;
            self.$emit("isIntentLoading", true);

            await self.$http.put(
                process.env.BARRAMUNDI +
                    "payment/stripe/payment-intent/" +
                    paymentIntentId,
                {
                    amount: amount,
                    business_id: self.data.business_id
                }
            );
            self.$emit("isIntentLoading", false);
        }
    },
    watch: {
        "data.payment_amount": {
            handler: debounce(function (newValue, oldValue) {
                if (
                    newValue !== null &&
                    newValue !== undefined &&
                    newValue !== "" &&
                    newValue !== 0 &&
                    newValue !== "0" &&
                    newValue > 0
                ) {
                    this.handlePaymentAmountChange(newValue);
                }
            }, 700),
            immediate: false
        }
    }
};
</script>
